import { CategoryService } from './../../../import/service/category.service';
import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { DataViewModule } from 'primeng/dataview';
import { Tree, TreeModule } from 'primeng/tree';
import { TableModule } from 'primeng/table';
import { TreeSelectModule } from 'primeng/treeselect';
import { FormsModule } from '@angular/forms';
import { PanelModule } from 'primeng/panel';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-taxonomy-attributes',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DataViewModule,
    TreeModule,
    TreeSelectModule,
    TableModule,
    PanelModule,
    TranslateModule,
  ],
  templateUrl: './taxonomy-attributes.component.html',
  styleUrl: './taxonomy-attributes.component.scss',
})
export class TaxonomyAttributesComponent implements OnChanges {
  @Input() categories;
  @Input() selectedLocale;

  attributes;
  loading = false;
  totalCount;
  selectedNode;
  selectedAttribute = null;
  channels;
  defaultLocale;
  selectedChannel;
  lookupValues;

  @ViewChild(Tree) tree: Tree;
  constructor(private readonly categoryService: CategoryService) {}

  ngOnChanges(): void {
    this.onClear();
  }

  intitAttributes() {
    this.attributes = [];
    this.selectedAttribute = null;
    this.categoryService.getAttributesByLocale(this.selectedNode?.categoryId, this.selectedLocale).subscribe({
      next: (res: any) => {
        this.attributes = res[1];
      },
    });
  }

  onNodeSelect(event) {
    this.selectedNode = event.node;
    this.intitAttributes();
  }

  onClear() {
    this.attributes = [];
    this.selectedNode = null;
    this.selectedAttribute = null;
  }

  selectAttribute(event) {
    this.tree.resetFilter();
    this.selectedAttribute = event.node;
  }
}
